<template>
  <div class="reporte-ventas-container">
    <!-- Header con botón y título centrado -->
    <div class="header-container">
      <div class="titulo-centrado">
        <h2 class="titulo-principal">Reporte de Ventas</h2>
        <p class="periodo-info" v-if="nombrePeriodo">{{ nombrePeriodo }}</p>
      </div>
      <vs-button
        color="primary"
        @click="irADespachos"
        class="boton-derecha"
      >
        Reportes base de datos
      </vs-button>
    </div>

    <!-- Loading state -->
    <div v-if="loading" class="loading-container">
      <div class="spinner"></div>
      <p>Cargando datos...</p>
    </div>

    <!-- Cards de ventas -->
    <div v-else-if="arrayDatosDocumentos.length > 0" >
      <div class="cards-container">
        <!-- Card Venta Bruta -->
        <div class="card venta-bruta">
          <div class="card-header">
            <div class="icon-container bruta">
              <i class="fas fa-chart-line"></i>
            </div>
          </div>
          <div class="card-body">
            <h1>{{ formatearMoneda(arrayDatosDocumentos[0].venta_bruta) }}</h1>
            <!-- <div class="label">Venta Bruta</div> -->
            <h4>Prefacturas y notas</h4>
          </div>
        </div>

        <!-- Card Venta Neta -->
        <div class="card venta-neta">
          <div class="card-header">
            <div class="icon-container neta">
              <i class="fas fa-dollar-sign"></i>
            </div>
          </div>
          <div class="card-body">
              <h1>{{ formatearMoneda(arrayDatosDocumentos[0].venta_neta) }}</h1>
            <!-- <div class="label">Venta Neta</div> -->
            <h4>Prefacturas y notas - descuentos</h4>
          </div>
        </div>

      </div>
      <div class="cards-container">
        <!--VENTA BRUTA CON DEVOLUCIONES-->
        <div class="card venta-bruta">
          <div class="card-header">
            <div class="icon-container bruta">
              <i class="fa-solid fa-tags"></i>
            </div>
          </div>
          <div class="card-body">
            <h1>{{ formatearMoneda(arrayDatosDocumentos[0].total_general_bruto_devoluciones) }}</h1>
            <h4>Prefacturas y notas - devoluciones</h4>
          </div>
        </div>
        <!--VENTA CON DEVOLUCIONES CON DESCUENTO-->
       <!-- Card Venta Neta -->
        <div class="card venta-neta">
          <div class="card-header">
            <div class="icon-container neta">
             <i class="fa-solid fa-tag"></i>
            </div>
          </div>
          <div class="card-body">
              <h1>{{ formatearMoneda(arrayDatosDocumentos[0].total_con_descuento_neta_con_devoluciones) }}</h1>
            <!-- <div class="label">(Venta Neta - devoluciones) - descuento</div> -->
            <h4>Prefacturas y notas - descuentos - devoluciones</h4>
          </div>
        </div>
      </div>
    </div>

    <!-- Estado sin datos -->
    <div v-else class="no-data-container">
      <div class="no-data-icon">
        <i class="fas fa-chart-bar"></i>
      </div>
      <h3>No hay datos disponibles</h3>
      <p>No se encontraron registros para el período seleccionado</p>
    </div>

    <br>

    <!-- Reporte Contabilidad -->
    <vx-card class="mb-5">
      <div class="reporte-contabilidad-header">
        <h3 class="reporte-titulo">
          <i class="fas fa-calculator"></i>
          Reporte Contabilidad
        </h3>
        <div class="botones-reporte">
          <vs-button
            color="primary"
            @click="toggleReporteAnual"
          >
            <i class="fas fa-chart-line"></i>
            {{ mostrarReporteAnual ? 'Ocultar Reporte' : 'Cargar Reporte' }}
          </vs-button>

          <vs-button
            v-if="mostrarReporteAnual"
            color="success"
            @click="recargarReporte"
            class="ml-2"
          >
            <i class="fas fa-sync-alt"></i>
          </vs-button>
        </div>
      </div>

      <!-- Componente del reporte -->
      <div v-if="mostrarReporteAnual" class="reporte-anual-container">
        <ReporteGeneralAnualVue
          :periodo_id="periodo_id"
          :nombrePeriodo="nombrePeriodo"
          :key="reporteAnualKey"
        />
      </div>
    </vx-card>
    <!--REPORTE DE PEDIDOS -->
    <vx-card>
      <ReporteVentasPedidosPagosVue :periodo_id="periodo_id" :nombrePeriodo="nombrePeriodo"/>
    </vx-card><br>
    <br>
    <!--REPORTE DE DESPACHOS-->
    <!-- <vx-card>
      <ReporteVentasDespachosPagosVue :periodo_id="periodo_id" :nombrePeriodo="nombrePeriodo"/>
    </vx-card>
    <br> -->
    <!--RESUMENT DE PAGOS-->
    <vx-card>
      <ReportePagosVue :periodo_id="periodo_id"/>
    </vx-card>
    <br>
    <!--REPORTE LIQUIDACIONES-->
    <vx-card>
      <ReporteVentasContratosPagosVue :periodo_id="periodo_id" :nombrePeriodo="nombrePeriodo"/>
    </vx-card>
    <br>
    <!---REPORTE ASESORES LIQUIDACIONES-->
    <vx-card>
       <!-- Título -->
      <h1 class="mt-5">Reporte Asesores verificaciones</h1>
      <br>
      <ReporteVentasPorAsesorLiquidadosVue/>
    </vx-card>
     <!-- <vx-card>
      <ReporteVentasPorLibroVue :periodo_id="periodo_id" :nombrePeriodo="nombrePeriodo"/>
    </vx-card> -->
    <!--REPORTE POR LIBRO-->
    <br>
    <vx-card>
      <ReporteVentasGlobalLibrosVue :periodo_id="periodo_id" :nombrePeriodo="nombrePeriodo"/>
    </vx-card>
    <!--REPORTE REGALADOS-->
    <br>
    <vx-card>
      <ReporteVentasRegaladosVue :periodo_id="periodo_id" :nombrePeriodo="nombrePeriodo"/>
    </vx-card>
    <!--REPORTE DEVOLUCIONES-->
    <br>
    <vx-card>
      <ReporteVentasDevolucionesVue :periodo_id="periodo_id" :nombrePeriodo="nombrePeriodo"/>
    </vx-card>
    <!--REPORTE PEDIDOS X FECHA-->
    <br>
    <vx-card>
      <ReporteVentasPedidosPorFechaVue :periodo_id="periodo_id" :nombrePeriodo="nombrePeriodo"/>
    </vx-card>
  </div>
</template>

<script>
import Generalmix from '../../../../../mixins/Generalmix'
const ReportePagosVue                           = () => import('../../../../pedidos/gerencia/reportes/ReportePagos.vue')
const ReporteContratosLiquidadosNoLiquidadosVue = () => import('../../../../pedidos/gerencia/reportes/ReporteContratosLiquidadosNoLiquidados.vue')
const ReporteVentasPedidosPagosVue              = () => import('./RporteVentasPedidosPagos.vue')
const ReporteVentasContratosPagosVue            = () => import('./ReporteVentasContratosPagos.vue')
const ReporteVentasPorAsesorLiquidadosVue       = () => import('./ReporteVentasPorAsesorLiquidados.vue')
const ReporteVentasGlobalLibrosVue              = () => import('./ReporteVentasGlobalLibros.vue')
const ReporteVentasRegaladosVue                 = () => import('./ReporteVentasRegalados.vue')
const ReporteVentasDevolucionesVue              = () => import('./ReporteVentasDevoluciones.vue')
const ReporteGeneralAnualVue                    = () => import('./ReporteGeneralAnual.vue')
const ReporteVentasPorLibroVue                  = () => import('./ReporteVentasPorLibro.vue')
const ReporteVentasPedidosPorFechaVue           = () => import('./ReporteVentasPedidosPorFecha.vue')
const ReporteVentasDespachosPagosVue            = () => import('./ReporteVentasDespachosPagos.vue')

export default {
  mixins: [Generalmix],
  components:{
    ReporteContratosLiquidadosNoLiquidadosVue,
    ReporteVentasContratosPagosVue,
    ReportePagosVue,
    ReporteVentasPedidosPagosVue,
    ReporteVentasPorAsesorLiquidadosVue,
    ReporteVentasGlobalLibrosVue,
    ReporteVentasRegaladosVue,
    ReporteVentasDevolucionesVue,
    ReporteGeneralAnualVue,
    ReporteVentasPorLibroVue,
    ReporteVentasPedidosPorFechaVue,
    ReporteVentasDespachosPagosVue
  },
  data() {
    return {
      arrayDatosDocumentos: [],
      loading: true,
      mostrarReporteAnual: false,
      loadingReporteAnual: false,
      reporteAnualKey: 0
    }
  },
  props: {
    periodo_id: {
      type: Number,
      default: 0
    },
    nombrePeriodo: {
      type: String,
      default: ''
    },
  },
  mounted() {
    this.f_obtenerReporteDocumentos()
  },
  methods: {
    f_obtenerReporteDocumentos() {
      this.loading = true
      this.$http.get(this.$server_url + `metodosGetVentas?reporteDocumentosVentaGeneral=1&periodo=${this.periodo_id}`)
        .then((res) => {
          this.loading = false
          if (res.data.status == 0) {
            this.m_message(res.data.message, 'danger')
          } else {
            this.arrayDatosDocumentos = res.data
            if (this.arrayDatosDocumentos.length == 0) {
              this.m_message('No hay datos para mostrar', 'warning')
            }
          }
        })
        .catch((error) => {
          this.loading = false
          console.log(error + ' error')
        })
    },
    formatearMoneda(valor) {
      return new Intl.NumberFormat('es-EC', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(valor)
    },
    abrirReporteAnual() {
      this.mostrarReporteAnual = true
    },
    toggleReporteAnual() {
      if (this.mostrarReporteAnual) {
        // Si está visible, lo ocultamos
        this.mostrarReporteAnual = false
      } else {
        // Si está oculto, lo mostramos
        this.mostrarReporteAnual = true
        // Incrementamos la key para forzar la recarga del componente
        this.reporteAnualKey += 1
      }
    },
    recargarReporte() {
      // Función específica para recargar el reporte
      // Incrementamos la key para forzar la recarga del componente
      this.reporteAnualKey += 1

      this.$vs.notify({
        title: 'Reporte Actualizado',
        text: 'El reporte se ha actualizado correctamente',
        color: 'success'
      })
    },
    irADespachos() {
      window.open(this.$server_url + 'admin/despachados/vista', '_blank');
    }
  }
}
</script>

<style scoped>
.reporte-ventas-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.header-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 30px;
  min-height: 80px;
}

.titulo-centrado {
  text-align: center;
  flex: 1;
}

.boton-derecha {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.header-section {
  text-align: center;
  margin-bottom: 30px;
}

.titulo-principal {
  color: #2c3e50;
  font-size: 2.2rem; /* más pequeño */
  font-weight: 700;
  margin-bottom: 10px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.periodo-info {
  color: #7f8c8d;
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
}

.botones-reportes {
  margin-top: 20px;
  text-align: center;
}

.categorias-header {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); /* más pequeño */
  gap: 15px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.categoria-item {
  text-align: center;
  padding: 12px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 10px;
  border: 1px solid #dee2e6;
}

.categoria-titulo {
  color: #2c3e50;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 4px 0;
}

.categoria-subtitulo {
  color: #6c757d;
  font-size: 0.85rem;
  margin: 0;
  font-weight: 500;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 250px;
  color: #7f8c8d;
}

.spinner {
  width: 35px;
  height: 35px;
  border: 4px solid #ecf0f1;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); /* cards más pequeños */
  gap: 15px;
  margin-bottom: 20px;
}

.card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
  padding: 8px;
}

.card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.12);
}

.venta-bruta {
  border-left: 4px solid #e74c3c;
}

.venta-neta {
  border-left: 4px solid #27ae60;
}

.card-header {
  padding: 10px;
  text-align: center;
}

.icon-container {
  width: 40px;
  height: 40px;
  margin: 0 auto;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: white;
}

.icon-container.bruta {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
}

.icon-container.neta {
  background: linear-gradient(135deg, #27ae60, #229954);
}

.card-body {
  padding: 10px;
  text-align: center;
}

.amount {
  font-size: 1.4rem; /* más pequeño */
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 6px;
  letter-spacing: -0.5px;
}

.label {
  color: #7f8c8d;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.card-footer {
  padding: 8px;
  text-align: center;
}


.no-data-container {
  text-align: center;
  padding: 50px 15px;
  color: #7f8c8d;
}

.no-data-icon {
  font-size: 3rem;
  color: #bdc3c7;
  margin-bottom: 15px;
}

.no-data-container h3 {
  color: #2c3e50;
  margin-bottom: 8px;
}

.resumen-container {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.resumen-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  text-align: center;
  min-width: 200px;
}

.resumen-card h4 {
  color: #2c3e50;
  margin-bottom: 12px;
  font-size: 1rem;
  font-weight: 600;
}

/* Responsive */
@media (max-width: 950px) and (min-width: 769px) {
  .header-container {
    flex-direction: column;
    gap: 20px;
    min-height: auto;
    text-align: center;
  }

  .boton-derecha {
    position: static;
    transform: none;
    align-self: center;
  }

  .titulo-centrado {
    margin-bottom: 0;
  }
}

@media (max-width: 768px) {
  .header-container {
    flex-direction: column;
    gap: 15px;
    min-height: auto;
  }

  .boton-derecha {
    position: static;
    transform: none;
  }

  .cards-container {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .categorias-header {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .titulo-principal {
    font-size: 1.8rem;
  }

  .amount {
    font-size: 1.3rem;
  }

  .card {
    margin: 0 8px;
  }
}

@media (max-width: 480px) {
  .reporte-ventas-container {
    padding: 15px 10px;
  }

  .titulo-principal {
    font-size: 1.5rem;
  }

  .amount {
    font-size: 1.2rem;
  }
}

.reporte-anual-section {
  text-align: center;
  padding: 20px;
}

.reporte-anual-section h1 {
  color: #2c3e50;
  margin-bottom: 10px;
}

.reporte-anual-section p {
  color: #7f8c8d;
  font-size: 1rem;
}

.reporte-contabilidad-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 20px;
}

.botones-reporte {
  display: flex;
  align-items: center;
  gap: 10px;
}

.reporte-titulo {
  color: #2c3e50;
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.reporte-titulo i {
  color: #3498db;
}

.reporte-anual-container {
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-top: 15px;
  position: relative;
}

/* Responsive para el header del reporte */
@media (max-width: 768px) {
  .reporte-contabilidad-header {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }

  .reporte-titulo {
    justify-content: center;
  }

  .botones-reporte {
    flex-direction: column;
    width: 100%;
  }

  .botones-reporte .vs-button {
    width: 100%;
    margin: 5px 0;
  }
}

</style>
